import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchFlights,
  fetchFlightById,
  createFlight,
  updateFlight,
  deleteFlight,
  restoreFlight,
  permanentDeleteFlight,
  exportFlights,
  cancelFlight,
  fetchFlightBookings,
  publishFlight,
  saveDraft,
  clearError,
  clearCurrentFlight
} from '../../store/slices/flightManagementSlice';

export const useFlightManagement = () => {
  const dispatch = useDispatch();
  const {
    flights,
    currentFlight,
    bookings,
    loading,
    error,
    pagination
  } = useSelector((state) => state.flightManagement);

  // Fetch all flights
  const loadFlights = useCallback((params) => {
    return dispatch(fetchFlights(params));
  }, [dispatch]);

  // Fetch single flight
  const loadFlightById = useCallback((id) => {
    return dispatch(fetchFlightById(id));
  }, [dispatch]);

  // Create new flight
  const addFlight = useCallback((data) => {
    return dispatch(createFlight(data));
  }, [dispatch]);

  // Update flight
  const editFlight = useCallback((id, data) => {
    return dispatch(updateFlight({ id, data }));
  }, [dispatch]);

  // Delete flight (soft delete)
  const removeFlight = useCallback((id) => {
    return dispatch(deleteFlight(id));
  }, [dispatch]);

  // Restore flight
  const restoreDeletedFlight = useCallback((id) => {
    return dispatch(restoreFlight(id));
  }, [dispatch]);

  // Permanently delete flight
  const permanentlyDeleteFlight = useCallback((id) => {
    return dispatch(permanentDeleteFlight(id));
  }, [dispatch]);

  // Cancel flight
  const cancelFlightById = useCallback((id) => {
    return dispatch(cancelFlight(id));
  }, [dispatch]);

  // Fetch flight bookings
  const loadFlightBookings = useCallback((id) => {
    return dispatch(fetchFlightBookings(id));
  }, [dispatch]);

  // Publish flight
  const publishFlightById = useCallback((id) => {
    return dispatch(publishFlight(id));
  }, [dispatch]);

  // Save as draft
  const saveFlightDraft = useCallback((data) => {
    return dispatch(saveDraft(data));
  }, [dispatch]);

  // Export flights
  const exportData = useCallback((format) => {
    return dispatch(exportFlights(format));
  }, [dispatch]);

  // Clear functions
  const clearFlightError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const clearCurrent = useCallback(() => {
    dispatch(clearCurrentFlight());
  }, [dispatch]);

  return {
    // State
    flights,
    currentFlight,
    bookings,
    loading,
    error,
    pagination,
    
    // Actions
    loadFlights,
    loadFlightById,
    addFlight,
    editFlight,
    removeFlight,
    restoreDeletedFlight,
    permanentlyDeleteFlight,
    cancelFlightById,
    loadFlightBookings,
    publishFlightById,
    saveFlightDraft,
    exportData,
    clearFlightError,
    clearCurrent
  };
};

export default useFlightManagement;
